// client/requestHandlers/queryCache.ts
import "../../metaDataStore";
import "../../protocol";
import { PassthroughHandler } from "../../requestHandler";
var QueryCache = class extends PassthroughHandler {
  constructor(upstream, map = {}, ttl = 1e3 * 60) {
    super(upstream);
    this.map = map;
    this.ttl = ttl;
  }
  async query(op, payload) {
    if (op.options.requestHandlerMeta?.queryCache.cachePolicy === "bypass") {
      console.log("DEBUG bypassing cache for op", op.name);
      return this.upstream.query(op, payload);
    }
    const key = (op.options.requestHandlerMeta?.queryCache?.cacheGroup ? op.options.requestHandlerMeta?.queryCache?.cacheGroup + "~" : "") + JSON.stringify(payload);
    if (this.map.hasOwnProperty(key)) {
      if (Date.now() - this.ttl < this.map[key].time)
        return this.map[key].value;
      delete this.map[key];
    }
    return this.upstream.query(op, payload).then((value) => (this.map[key] = { time: Date.now(), value }).value);
  }
  async mutation(op, payload) {
    if (op.name === "resolveLoginToken")
      this.clear();
    return this.upstream.mutation(op, payload);
  }
  destroy() {
    this.clear();
    super.destroy();
  }
  clear() {
    this.map = {};
  }
  invalidateGroup(group) {
    for (const key of Object.keys(this.map)) {
      if (key.startsWith(group))
        delete this.map[key];
    }
  }
};
export {
  QueryCache
};
